import { getSessionCookie } from './session';
import { getSubdomain } from '../utils/helper';
import { ANALYTICS_API_URL } from '../constants/constants';
import { config } from '../constants/domainConfig';
import { getText } from '../constants/multiDomains';

export const sendData = (cName, cCategory, cType, uType, additionalParams) => {
    const sessionId = getSessionCookie();
    const subDomain = getSubdomain();
    const args = {
        url: window.location.href,
        lang: config.lang
    }
    let rockmanId = sessionStorage.getItem('authorized') && JSON.parse(sessionStorage.getItem('authorized')) ? JSON.parse(sessionStorage.getItem('authorized')).subscriptionInfo ? JSON.parse(sessionStorage.getItem('authorized')).subscriptionInfo.rockmanId : '' :'';
    let rid = new URL(window.location.href).searchParams.get('rid')
    if((rockmanId && rockmanId.length > 0) || (rid && rid.length > 0)){
        const data = {
            r: rockmanId && rockmanId.length > 0 ? rockmanId : rid,
            portal_session_id: sessionId,
            d: [
                {
                    t: "content_usage",
                    a: {
                        content_name: cName,
                        content_category: cCategory,
                        content_type: cType,
                        usage_type: uType,
                        args: { ...args, ...additionalParams },
                        product_name: getText().toLowerCase(),
                        subdomain: subDomain
                    }
                }
            ]
        };
        if(getSubdomain() === 'localhost'){
            console.log(data)
            return;
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', ANALYTICS_API_URL, true);
        // xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(data));
    }
    return;
}


// WEBPACK FOOTER //
// ./src/analytics/sendData.js